import { useId } from 'react';

import Star from '@mui/icons-material/Star';
import PropTypes from 'prop-types';

import { superstyled, useTheme } from '@zenbusiness/zui/styles';

import {
  ReviewsCardRoot as Card,
  ReviewsCardContent as CardContent,
  ReviewsCardStack as Stack,
  ReviewsCardTitle as Title,
  ReviewsCardDescription as Description
} from './ReviewsCard.style';

export const Rating = superstyled({
  name: 'Rating',
  slot: 'Rating',
  styles: ({ theme }) => ({
    display: 'flex',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  })
});

export default function ReviewsCard({ review, reviewer, starCount, children, ...delegated }) {
  const theme = useTheme();
  const uniqueId = useId();
  const cardId = delegated.id ?? uniqueId;
  const labelledby = `${cardId}-reviews-review`;
  const describedby = `${cardId}-reviews-reviewer`;

  return (
    <Card aria-describedby={describedby} aria-labelledby={labelledby} {...delegated}>
      <CardContent>
        <Stack>
          {review && <Description id={describedby}>{review}</Description>}
          {reviewer && <Title id={labelledby}>{reviewer}</Title>}
          <Rating>
            {Array.from({ length: Math.min(starCount) }).map((_, index) => (
              <Star
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                color={theme.palette.background.orange.main}
                height={24}
                width={24}
              />
            ))}
          </Rating>
        </Stack>
      </CardContent>
    </Card>
  );
}

ReviewsCard.propTypes = {
  color: PropTypes.oneOf([
    'default',
    'paper',
    'grey',
    'black',
    'red',
    'orange',
    'green',
    'cyan',
    'blue',
    'purple',
    'pink'
  ]),
  reviewer: PropTypes.node,
  review: PropTypes.node,
  starCount: PropTypes.number,
  variant: PropTypes.oneOf(['outlined', 'elevation'])
};
